import React from 'react';
import { Image } from 'react-native';

import QrCode from 'react-qrcode-svg';
import { Assets } from 'src/assets';
import { Container } from 'src/components';
import { AppColors, CustomShadow } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';

export const CustomQRCode = ({ data, isAnimate = true }: { data: any; isAnimate?: boolean }) => {
  return (
    <Container
      style={{
        backgroundColor: AppColors.white,
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        borderRadius: metrics.borderRadius,
        overflow: 'hidden',
        padding: metrics.large,
        ...CustomShadow,
      }}>
      <QrCode margin={0} data={data} height="150" width="150" fgColor="url(#gradientFill)" bgColor={AppColors.white}>
        <linearGradient id="gradientFill" x1="0" y1="0" x2="1" y2=".7">
          <stop offset="0%" stopColor="#26BAAE" />
          <stop offset="100%" stopColor="#186693" />
        </linearGradient>
      </QrCode>
      {isAnimate ? (
        <Image
          source={Assets.Nham24IconGif}
          style={{
            borderWidth: 3,
            borderColor: AppColors.white,
            borderRadius: 20,
            width: pixelScaler(28),
            height: pixelScaler(28),
            position: 'absolute',
            alignSelf: 'center',
          }}
        />
      ) : (
        <Image
          source={Assets.Nham24Icon}
          style={{
            borderWidth: 3,
            borderColor: AppColors.white,
            borderRadius: 20,
            width: pixelScaler(35),
            height: pixelScaler(35),
            position: 'absolute',
            alignSelf: 'center',
          }}
        />
      )}
    </Container>
  );
};
